import { useMemo } from 'react'
import isEmpty from 'lodash/isEmpty'

function useAuthority(userAuthority = [], authority = [], emptyCheck = false) {

    const roleMatched = useMemo(() => {
		// If no authority requirements, allow access (based on emptyCheck)
		if (isEmpty(authority)) {
			return !emptyCheck
		}
		
		// If user has no authority yet (initial state before Redux loads), show all temporarily
		// This prevents hiding everything during initial page load
		if (isEmpty(userAuthority)) {
			return !emptyCheck  // By default true to show items during load
		}
		
		// Check if user has any of the required authorities
		return authority.some(role => userAuthority.includes(role))
	}, [authority, userAuthority, emptyCheck])
    
    return roleMatched
}

export default useAuthority